import { render, staticRenderFns } from "./InterestFollowUpAdd.vue?vue&type=template&id=77cfef74&"
import script from "./InterestFollowUpAdd.vue?vue&type=script&lang=js&"
export * from "./InterestFollowUpAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports